import { render, staticRenderFns } from "./AddNewAlbumDrawerContent.vue?vue&type=template&id=33c99417&scoped=true"
import script from "./AddNewAlbumDrawerContent.vue?vue&type=script&lang=js"
export * from "./AddNewAlbumDrawerContent.vue?vue&type=script&lang=js"
import style0 from "./AddNewAlbumDrawerContent.vue?vue&type=style&index=0&id=33c99417&prod&scoped=true&lang=css"
import style1 from "./AddNewAlbumDrawerContent.vue?vue&type=style&index=1&id=33c99417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c99417",
  null
  
)

export default component.exports